import {
  BasePropertyDTO,
  DispensingPropertiesDTO,
  EnumElementDTO,
  GlobalPreferencesClient,
  PreferenesDTO,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';
import { ExperimentDispensingProperties } from 'components/Experiment/constants';
import { getPlainExperimentDispensingProperties } from 'transformers/experiment';

export class GlobalPreferencesService extends BaseService {
  async getAllPropNames(
    currentPreference: string,
    groupId?: number,
  ): Promise<BasePropertyDTO[]> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.getAllPropNames(currentPreference, groupId);
  }

  async setAllProperties(preferenes: PreferenesDTO, groupId?: number): Promise<boolean> {
    const gpClient: GlobalPreferencesClient = ModelFactory(GlobalPreferencesClient);
    return await gpClient.save(preferenes, groupId);
  }

  async getProperty(propertyName: string): Promise<BasePropertyDTO> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.get(propertyName);
  }

  async getProperties(propertyNames: string[]): Promise<BasePropertyDTO[]> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.getProperties(propertyNames);
  }

  async getUserProperty(propertyName: string): Promise<BasePropertyDTO> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.getUserProperty(propertyName);
  }

  async getPropertiesByName(name: string): Promise<EnumElementDTO[]> {
    const gpClient: GlobalPreferencesClient = ModelFactory(GlobalPreferencesClient);
    return await gpClient.getPropertiesByName(name);
  }

  async getDispensingProperties(
    containerId: number,
    expId: number,
  ): Promise<ExperimentDispensingProperties> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return getPlainExperimentDispensingProperties(
      await gpClient.getExpDriverProperties(containerId, expId),
    );
  }

  async getGlobalDispensingProperties(): Promise<DispensingPropertiesDTO> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.getDispensingProperties();
  }

  async saveGlobalDispensingProperties(
    properties: DispensingPropertiesDTO,
  ): Promise<boolean> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.saveGeneralDispensingProperties(properties);
  }

  async getUserGroupAdminStatus(): Promise<boolean> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.getUserGroupAdminStatus();
  }
  async getAllMotherPlatesScoringStatuses(
    experimentId: number,
  ): Promise<{ [key: string]: boolean }> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.checkMotherPlateScoringEnabled(experimentId);
  }

  async resetPreferences(tag: string, groupId: number = -1): Promise<boolean> {
    const gpClient: GlobalPreferencesClient = ModelFactory(
      GlobalPreferencesClient,
      false,
      true,
    );
    return await gpClient.resetPreferences(tag, groupId);
  }
}
